<template>
  <v-expansion-panels accordion>
    <v-expansion-panel>
      <v-expansion-panel-header>
        <h2>Admin Commands</h2>
      </v-expansion-panel-header>

      <v-expansion-panel-content>
        <button
          class="default-btn blue"
          :disabled="clickedRefreshReviewScores"
          @click="refreshReviewScores">
          Refresh review scores
        </button>

        <p class="help">
          In the event that review scores may have gotten out of sync, you can use this. It will poll all of the reviews and recalculate their scores, in addition to the product/organization scores associated with them.
        </p>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'AdminDashboardCommands',

  data: () => ({
    clickedRefreshReviewScores: false,
  }),

  methods: {
    ...mapActions('feathers', ['sendCommand']),

    async refreshReviewScores () {
      this.clickedRefreshReviewScores = true

      try {
        const result = await this.sendCommand('refresh-review-scores')
        this.addSuccessAlert(result.message)
      } catch (error) {
        this.addErrorAlert(error.message)
        this.clickedRefreshReviewScores = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.v-expansion-panels {
  margin-top: -50px;
  margin-bottom: 50px;
}

::v-deep {
  .v-expansion-panel {
    .v-expansion-panel-header {
      background-color: $secondaryBlue;

      h2, .v-icon {
        color: white !important;
      }
    }

    &--active {
      .v-expansion-panel-header__icon .v-icon {
        transform: rotate(90deg) !important;
      }
    }

    .v-expansion-panel-content__wrap {
      padding: 20px 25px;
    }
  }
}
</style>
